import { render, staticRenderFns } from "./dateModal.vue?vue&type=template&id=04bf27e2"
import script from "./dateModal.vue?vue&type=script&lang=js"
export * from "./dateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports